import { getCarHireItemsView } from 'checkout/selectors/view/carHire'
import { excludeNullOrUndefined } from 'checkout/utils'
import { sum } from 'lib/arrayUtils'
import createSelector from 'lib/createSelector'

export const getCarHireTotals = createSelector(
  getCarHireItemsView,
  (state: App.State) => state.checkout.cart.carHireAddons,
  (state: App.State) => state.checkout.cart.carHireInsurance,
  (viewWithStatus, cartAddons, selectedCarHireInsurance): App.WithDataStatus<App.Checkout.ItemTotals> => {
    const definedItems = viewWithStatus.data.filter(excludeNullOrUndefined)
    const addonsFees = sum(Object.values(cartAddons), addon => addon.total * (addon.quantity || 1))
    const paidOnPickUpFees = sum(definedItems, itemView => itemView.taxesAndFees ?? 0)
    const insuranceCost = selectedCarHireInsurance && selectedCarHireInsurance.type === 'enhanced' ? selectedCarHireInsurance.total : 0

    return {
      hasRequiredData: viewWithStatus.hasRequiredData,
      data: {
        price: sum(definedItems, itemView => itemView.item.offer.payNowAmount) + insuranceCost,
        value: sum(definedItems, itemView => itemView.value ?? 0),
        surcharge: 0,
        taxesAndFees: 0,
        carHirePaidOnPickUpFees: addonsFees + paidOnPickUpFees,
        carHireAddonFees: addonsFees,
      },
    }
  },
)
